import React from 'react'

class Loader extends React.Component{

  constructor(props){
    super(props);
  }


  ellipsisLoader(){
    return
  }

  render(){
    var {type, className, style, height, width} = this.props;
    const apparatusLoader = <div className={`logo_spinner_logo ${className ? className : ""}`}>
        <div className="logo_spinner_outline"></div>
        <div className="logo_spinner_bg"></div>
      </div>

    const spinnerLoader = <div style={Object.assign({}, style)} className={`lds-spinner ${className ? className : ""}`}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>

    var lineStyle = {};
    if(height){ lineStyle.height = height + 'px'; }
    if(width){ lineStyle.width = width + 'px'; }
    if(style){ lineStyle = Object.assign(lineStyle, style) }
    const lineLoader = <div className={`line-loader ${className ? className : ""}`} style={lineStyle}></div>

    if(type === 'spinner'){
      return spinnerLoader;
    } else if(type === 'line'){
      return lineLoader;
    } else if(type === 'ellipsis'){
      return <EllipsisLoader className={className} style={style} />
    } else {
      return apparatusLoader;
    }

  }

}

class EllipsisLoader extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      incrementor: 0
    }
  }

  componentDidMount(){
    var that = this;
    this.animationInterval = window.setInterval(() => {
      that.setState({
        incrementor: that.state.incrementor + 1
      })
    }, 600);
  }

  componentWillUnmount(){
    window.clearInterval(this.animationInterval);
  }

  render(){
    var {incrementor} = this.state;
    var {className, style} = this.props;
    return <span style={Object.assign({}, style)} className={`${className ? className : ""}`}>{".".repeat(incrementor % 4)}</span>
  }
}

export default Loader;